export default "__VITE_ASSET__KOEEI4Ai__"